module.exports = "/_next/static/images/device-color-board@2x-min-20f3bc6c5226e9f2c4f09919fba2bd76.png";